import { FRASiteTests } from "../FRA_Crossing/CombinedForms";
import { CPSiteTests } from "../../CP/NewCrossingReport/CombinedForms";

const SITE_Grade_Crossing = {
  testDescription: "Highway Grade Crossing",
  title: {
    _id: "gcwsatr",
    title: "Test & Inspection Report",
  },
  reportCode: "HighwayGradeCrossing",
  combineCodes: CPSiteTests,
};

const CP_Grade_Crossing = {
  testDescription: "Highway Grade Crossing",
  title: {
    _id: "CPGradeCrossing",
    title: "Test & Inspection Report",
  },
  reportCode: "CPGradeCrossing",
  combineCodes: CPSiteTests,
};

const Periodic = {
  testDescription: "Periodic Combined",
  title: {
    _id: "periodic",
    title: "Periodic Combined Reports",
  },

  reportCode: "periodic",

  combineCodes: [
    { code: "periodic92Days" },
    { code: "periodic184Days" },
    { code: "periodic368Days" },
    { code: "handBreakTest105c" },
    { code: "eventRecordTest25d" },
    { code: "eventRecordMicroprocessorTest27c" },
    { code: "GandO368Days" },
    { code: "emdPrimeMoverInspection" },
  ],
};
const AirBrake = {
  testDescription: "AirBrake Reports",
  title: {
    _id: "airbrake",
    title: "AirBrake Combined Reports",
  },

  reportCode: "airbrake",

  combineCodes: [
    { code: "AirBrakeAFMLevelOne" },
    { code: "AirBrakeSys1Lvl2" },
    { code: "AirBrakeSys2Lvl2" },
    { code: "AirBrakeSys3Lvl2" },
    { code: "AirBrakeSys4Lvl2" },
    { code: "AirBrakeSys1Lvl3" },
    { code: "AirBrakeSys2Lvl3" },
    { code: "AirBrakeSys3Lvl3" },
    { code: "AirBrakeSys4Lvl3" },
    { code: "AirBrakeAFM92Days" },
  ],
};
const EventRecorder = {
  testDescription: "Event Recorder Reports",
  title: {
    _id: "eventRecorder",
    title: "Event Recorder Reports",
  },

  reportCode: "eventRecorder",

  combineCodes: [{ code: "eventRecordTest25d" }, { code: "eventRecordMicroprocessorTest27c" }],
};
const FRA_Grade_Crossing = {
  //not used
  testDescription: "Grade Crossing Warning System Annual Test Report",
  title: {
    _id: "hgcr",
    title: "Highway Grade Crossing Inspection",
  },
  reportCode: "GradeCrossingWarningReport",

  combineCodes: [
    { code: "grade_1001b1" },
    { code: "grade_303" },
    { code: "grade_201" },
    { code: "grade_202" },
    { code: "grade_203" },
    { code: "grade_1001(b)2" },
    { code: "grade_1001(b)3" },
    { code: "grade_1001(b)4" },
    { code: "grade_1001(b)5" },
    { code: "grade_1001(b)6" },
    { code: "grade_1001(b)7" },
    { code: "grade_1001(b)8" },
    { code: "grade_801" },
    { code: "grade_703" },
    { code: "grade_1001(c)1" },
    { code: "grade_401(a)" },
    { code: "grade_701" },
    { code: "grade_1001(d)1" },
    { code: "grade_1001(d)2" },
    { code: "grade_1001(e)1" },
    { code: "grade_1001(e)2" },
    { code: "grade_1001(e)3" },
    { code: "grade_702" },
    { code: "grade_1001(e)4" },
    { code: "grade_1001(e)5" },
    { code: "grade_1001(e)6" },
    { code: "grade_1001(e)7" },
    { code: "grade_1001(e)8" },
    { code: "grade_402" },
    { code: "grade_901" },
    { code: "grade_1101" },
    { code: "grade_1001(e)9" },
    { code: "grade_1106" },
  ],
};

const SFRTASwitchMonthlyReport = {
  //not used
  testDescription: "Switch Monthly Tests",
  title: {
    _id: "sfrtasMTests",
    title: "Switch Monthly Tests",
  },
  reportCode: "sfrtaSwitchMTests",
  combineCodes: [{ code: "sfrtaSwitchLockRodNormal" }, { code: "sfrtaSwitchLockRodReverse" }],
};
const SFRTASwitchQuarterReport = {
  // not used
  testDescription: "Switch Quarterly Tests",
  title: {
    _id: "sfrtasQTests",
    title: "Switch Quarterly Tests",
  },
  reportCode: "sfrtaSwitchQTests",
  combineCodes: [
    { code: "sfrtaSwitchcircuitControllerNormal" },
    { code: "sfrtaSwitchcircuitControllerReverse" },
    { code: "sfrtaSwitchshuntFouling" },
  ],
};

const SFRTAInterlockingReport = {
  testDescription: "Locking Tests & Inspections",
  title: {
    _id: "sfrtaLockingTests",
    title: "Locking Tests & Inspections",
  },
  reportCode: "sfrtaInterLockingTests",
  combineCodes: [
    { code: "sfrtaMechanical236_376" },
    { code: "sfrtaApproach236_377" },
    { code: "sfrtaTime236_378" },
    { code: "sfrtaRoute236_379" },
    { code: "sfrtaIndication236_380" },
    { code: "sfrtaTraffic236_381" },
  ],
};
const SFRTAHotBoxDefectDetectorReport = {
  testDescription: "Hot Box Defect Detector Tests",
  title: {
    _id: "sfrtaHotBoxDefectTests",
    title: "Hot Box Defect Detector Tests",
  },
  reportCode: "sfrtaHotBoxDefectDetectorTests",
  combineCodes: [{ code: "sfrtaHotBox30Days" }, { code: "sfrtaHotBox90Days" }, { code: "sfrtaDraggingEquip30Days" }],
};
const SFRTASwitchTestsReport = {
  testDescription: "Switch Tests",
  title: {
    _id: "sfrtaSwitchTests",
    title: "Switch Tests",
  },
  reportCode: "sfrtaSwitchTests",
  combineCodes: [
    // Quarterly
    { code: "sfrtaSwitchcircuitControllerNormal" },
    { code: "sfrtaSwitchcircuitControllerReverse" },
    { code: "sfrtaSwitchshuntFouling" },
    // Monthly
    { code: "sfrtaSwitchLockRodNormal" },
    { code: "sfrtaSwitchLockRodReverse" },
    // Quarterly
    { code: "CN_Quarterly_SwitchCircuitControllerNormal_FRA236_103" },
    { code: "CN_Quarterly_SwitchCircuitControllerReverse_FRA236_103" },
    { code: "CN_Quarterly_FoulingCircuits_FRA236_104" },
    // Monthly
    { code: "CN_Monthly_SwitchObstructionNormal_FRA236_382" },
    { code: "CN_Monthly_SwitchObstructionReverse_FRA236_382" },
    //Quarterly
    { code: "path_valueLocksNonCutOffQuaterly" },
    { code: "path_restoreFeatureOnPowerSwitches" },
    //Annually
    { code: "path_valvesAndValveMagnets" },
  ],
};

const ATLASInspectionConnection = {
  testDescription: "Inspection and Connections",
  title: {
    _id: "atlasInspectionConnection",
    title: "Inspection and Connections",
  },

  reportCode: "atlasInspectionConnection",

  combineCodes: [
    //rotor blades
    { code: "atlasRotorBladeVisualInspection" },
    { code: "atlasRotorBladeTorqueScrewConnections" },
    //drive train
    { code: "atlasDrivetrainTorqueScrewConnections" },
    { code: "atlasDrivetrainVisualInspection" },
    { code: "atlasDrivetrainLubricationInspection" },
    //support structure
    { code: "atlasSupportStructureVisualInspection" },
    { code: "atlasSupportStructureTorqueScrewConnections" },
  ],
};
const ONRSwitchTestsReport = {
  testDescription: "Switch Tests",
  title: {
    _id: "onrSwitchTests",
    title: "Switch Tests",
  },
  reportCode: "onrSwitchTests",
  combineCodes: [
    // SemiAnnual
    { code: "onr_SemiAnnual_HydraulicMotorCurrentTest" },

    // Quarterly
    { code: "onr_Quarterly_BatteryVoltageTest" },

    // Monthly
    { code: "onr_Monthly_SwitchVisualInspection" },
    { code: "onr_Monthly_SwitchObstructionNormal" },
    { code: "onr_Monthly_SwitchObstructionReverse" },
    { code: "onr_Monthly_PointPressureTest" },
    { code: "onr_Monthly_SwitchMachineOperation" },

    //annual

    { code: "onr_Annual_SwitchMachineOperation" },
    { code: "onr_Annual_TransducerOccupancyDTMFOperation" },
  ],
};

const HBReport = {
  testDescription: "Hot Box Detector",
  title: {
    _id: "hbdTests",
    title: "Hot Box Detector",
  },
  reportCode: "hbdTests",
  combineCodes: [
    { code: "ONR_be0a4_HBD" },
    { code: "ONR_be1a5_HBD" },
    { code: "ONR_be2a6_HBD" },
    { code: "ONR_be3a7_HBD" },
    { code: "ONR_be4a8_HBD" },
    { code: "ONR_be5a9_HBD" },
    { code: "ONR_be6a10_HBD" },
    { code: "ONR_be7a11_HBD" },
    { code: "ONR_be0b1_HBD" },
    { code: "ONR_be1b2_HBD" },
    { code: "ONR_be2b3_HBD" },
    { code: "ONR_be3b4_HBD" },
    { code: "ONR_be4b5_HBD" },
    { code: "ONR_bu0a25_HBD" },
    { code: "ONR_bu1a26_HBD" },
    { code: "ONR_bu2a27_HBD" },
    { code: "ONR_bu3a28_HBD" },
    { code: "ONR_bu4a29_HBD" },
    { code: "ONR_bu0b17_HBD" },
    { code: "ONR_bu1b18_HBD" },
    { code: "ONR_bu3b20_HBD" },
    { code: "ONR_bu0ssit203_HBD" },
    { code: "ONR_bu0ssit1001e7_HBD" },
    { code: "ONR_bu1ssit901_HBD" },
    { code: "ONR_bu0ssit1101_HBD" },
    { code: "ONR_bu1ssit1103_HBD" },
    { code: "ONR_bu2ssit1104_HBD" },
    { code: "ONR_de0a16_HBD" },
    { code: "ONR_de1a17_HBD" },
    { code: "ONR_de2a18_HBD" },
    { code: "ONR_de3a19_HBD" },
    { code: "ONR_de4a20_HBD" },
    { code: "ONR_de0b9_HBD" },
    { code: "ONR_de1b10_HBD" },
    { code: "ONR_de2b11_HBD" },
    { code: "ONR_de3b12_HBD" },
    { code: "ONR_de4b13_HBD" },
    { code: "ONR_ho0a21_HBD" },
    { code: "ONR_ho1a22_HBD" },
    { code: "ONR_ho2a23_HBD" },
    { code: "ONR_ho3a24_HBD" },
    { code: "ONR_ho0b14_HBD" },
    { code: "ONR_ho1b15_HBD" },
    { code: "ONR_ho2b16_HBD" },
    { code: "ONR_tr0a1_HBD" },
    { code: "ONR_tr1a2_HBD" },
    { code: "ONR_tr2a3_HBD" },
    { code: "ONR_tr0na_HBD" },
    { code: "ONR_tr1na_HBD" },
    { code: "ONR_tr2na_HBD" },
    { code: "ONR_tr0a12_HBD" },
    { code: "ONR_tr1a13_HBD" },
    { code: "ONR_tr2a14_HBD" },
    { code: "ONR_tr3a15_HBD" },
    { code: "ONR_tr0b6_HBD" },
    { code: "ONR_tr1b7_HBD" },
    { code: "ONR_tr2b8_HBD" },
    {
      code: "ONR_be2c1_HBD",
    },
    {
      code: "ONR_be2c2_HBD",
    },
    {
      code: "ONR_ho1b4_HBD",
    },
    {
      code: "ONR_bu1b5_HBD",
    },
    {
      code: "ONR_bu1b6_HBD",
    },
  ],
};

const LIRRCrossingTests = {
  testDescription: "Highway Grade Crossing",
  title: {
    _id: "lirrHighwayGradeCrossing",
    title: "Test & Inspection Report",
  },
  reportCode: "lirrHighwayGradeCrossing",
  combineCodes: [
    { code: "LIRR_ACPowerGroundsFRA234_249" },
    { code: "LIRR_StandbyPowerFRA234_251" },
    { code: "LIRR_trackBatteries" },
    { code: "LIRR_FlasherLightsFRA234_217_253" },
    { code: "LIRR_GateArmsMechanismAndLightsFRA234_219_223_255" },
    { code: "LIRR_GateOperationFRA234_223_255" },
    { code: "LIRR_MiscWarningSystemOperationFRA235_257" },
    { code: "LIRR_TrafficPreEmptionFRA234_261" },
  ],
};

const LIRRSwitchTests = {
  testDescription: "Switch Tests",
  title: {
    _id: "lirrSwitchTestsAndInspection",
    title: "Switch Tests",
  },
  reportCode: "lirrSwitchTestsAndInspection",
  combineCodes: [{ code: "LIRR_30DaySwitchObstructionTest" }, { code: "LIRR_90DaySwitchCircuitControllers" }],
};

const ETRWeeklyTests = {
  testDescription: "Weekly Crossing Test",
  title: {
    _id: "etrWeeklyReport",
    title: "Weekly Crossing Test",
  },
  reportCode: "etrWeeklyReport",
  combineCodes: [{ code: "ETR_WeeklyTests" }],
};

const ETRGCPTests = {
  testDescription: "CW & MS GCP 3000/4000",
  title: {
    _id: "etrGCPReport",
    title: "CW & MS GCP 3000/4000",
  },
  reportCode: "etrGCPReport",
  combineCodes: [{ code: "ETR_CW_MSGCP3000_4000" }],
};

const ETR62590Tests = {
  testDescription: "CW & MS 62590",
  title: {
    _id: "etr62590Report",
    title: "CW & MS 62590",
  },
  reportCode: "etr62590Report",
  combineCodes: [{ code: "ETR_CW_MS62590" }],
};

const ComplianceReturnReport = {
  testDescription: "Compliance Return Form",
  title: {
    _id: "nonCompliantBackToService",
    title: "Compliance Return Report",
  },
  reportCode: "nonCompliantBackToService",
  combineCodes: [{ code: "nonCompliantBackToService" }],
};

export const combineCodesList = [
  SITE_Grade_Crossing,
  FRA_Grade_Crossing,
  CP_Grade_Crossing,
  SFRTASwitchTestsReport,
  SFRTASwitchMonthlyReport,
  SFRTASwitchQuarterReport,
  SFRTAInterlockingReport,
  SFRTAHotBoxDefectDetectorReport,
  ATLASInspectionConnection,
  ONRSwitchTestsReport,
  LIRRCrossingTests,
  LIRRSwitchTests,
  Periodic,
  AirBrake,
  EventRecorder,
  HBReport,
  ETRWeeklyTests,
  ETRGCPTests,
  ETR62590Tests,
  ComplianceReturnReport,
];



// WEBPACK FOOTER //
// ./src/components/Reports/sims/CombineMethods/CombineTests.js